import React from 'react';
import { Link } from 'react-router-dom';

const Navigation = (props) => {
  const { logo } = props;
  return (
    <div className="container-fluid app-nav-bar">
      <div className="container">
      <div className="row">
      <nav className="navbar-test ">

          <Link to="/">
            <img alt="" src={logo} />
          </Link>

      </nav>
      </div>
      </div>
    </div >
  );
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/Navigation/index.js